import React from "react";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import pro3p1 from "../../../images/project3-p1.png";
import pro3p2 from "../../../images/project3-p2.png";
import pro3p3 from "../../../images/project3-p3.png";

const Project03 = () => {
  return (
    <Container className="font mt-5">
      <h1 className="text-center  ">
        Star HealthCare <span className="heading">BD</span>
      </h1>

      <Container className=" mt-5 p-5 project-bg project-container border border-4 border-info rounded  ">
        <Row>
          <h2 className="fw-bold text-center mb-4">Description</h2>
          <Col sm={12} md={6} lg={6}>
            <h5 className="text-secondary">
              It is a website where a patient can easily get treatment for his
              desired disease. A user can select his service according to his
              disease. Moreover a user can read latest health related news. Here
              are more facilities for a user.{" "}
            </h5>

            <li>User can login or Sign up with Email and Password.</li>
            <li>
              A user can book, see and delete a service according to his
              disease.
            </li>
            <li>User can only login After Email Verification</li>
            <h5 className="mt-2">
              Frontend:{" "}
              <span>
                {" "}
                <span className="badge bg-info m-1">HTML 5</span>
                <span className="badge bg-info">CSS3</span>
                <span className="badge bg-info m-1 ">Bootstrap</span>
                <span className="badge bg-info">React.js</span>
                <span className="badge bg-info m-1">JavaScript(ES6)</span>
                <span className="badge bg-info m-1">React Router</span>
              </span>{" "}
            </h5>

            <h5>
              Link:{" "}
              <span>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://star-healthcare-bd.web.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Live
                </a>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://github.com/moshiur01/Star-HealthCare-BD"
                  target="_blank"
                  rel="noreferrer"
                >
                  Client Side
                </a>
              </span>{" "}
            </h5>
          </Col>
          <Col sm={12} md={6} lg={6} className="my-auto">
            <Carousel className=" carousel-img  border rounded  border-3 border-info ">
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid "
                  src={pro3p1}
                  alt="First slide"
                />
              </Carousel.Item>
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid"
                  src={pro3p2}
                  alt="Second slide"
                />
              </Carousel.Item>
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid"
                  src={pro3p3}
                  alt="Third slide"
                />
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Project03;
